var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "callout",
    {
      attrs: {
        "apply-border-top": "",
        "border-color": _vm.getAppointmentStatusColor(
          _vm.value.statusId != null ? _vm.value.statusId : 0
        ),
        controlled: true,
        "has-toggle": true,
        opened: _vm.value.isOpen
      },
      on: { "click:open": _vm.showDetail },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "fiscal-calendar-container mt-2" },
                [
                  _c("fiscal-calendar", {
                    staticClass: "fiscal-calendar",
                    attrs: { year: _vm.value.fiscalYearName },
                    on: {
                      "on-datarange-changed": _vm.onDetailDatarangeChanged
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "filters",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      },
                      {
                        key: "details",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "clearfix" }),
                            _c(
                              "div",
                              { staticClass: "col-sm-12" },
                              [
                                _vm._l(_vm.page.data, function(
                                  rowItem,
                                  rowIndex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: `row-item-${rowIndex}`,
                                      staticClass: "mt-2 c-cardContainer"
                                    },
                                    [
                                      _c(
                                        "callout",
                                        {
                                          attrs: {
                                            "border-color": _vm.getAppointmentStatusColor(
                                              rowItem.statusId != null
                                                ? rowItem.statusId
                                                : 0
                                            ),
                                            "has-toggle": true
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "edition",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "appointment-detail"
                                                      },
                                                      [
                                                        rowItem.statusId != null
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row header-row"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col"
                                                                  },
                                                                  [
                                                                    _c("em", {
                                                                      staticClass:
                                                                        "fas fa-info-circle color-orange mr-2"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-gray-7 font-weight-bold font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Información del Estudiante "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        rowItem.statusId != null
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row data-row"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "color-secondary-6 font-weight-normal font-14"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Estudiante: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              rowItem.student
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "color-secondary-6 font-weight-normal font-14"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Contacto: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              rowItem
                                                                                .contactInformation
                                                                                .fullName
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("div", {
                                                                      staticClass:
                                                                        "clearfix"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "phone"
                                                                              )(
                                                                                rowItem
                                                                                  .contactInformation
                                                                                  .telephoneHomeNo
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c("div", {
                                                                      staticClass:
                                                                        "clearfix"
                                                                    }),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "email"
                                                                              )(
                                                                                rowItem
                                                                                  .contactInformation
                                                                                  .email
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-4"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "color-secondary-6 font-weight-normal font-14"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Dirección: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              rowItem.studentAddress1
                                                                            ) +
                                                                            _vm._s(
                                                                              rowItem.studentAddress2
                                                                                ? `, ${rowItem.studentAddress2}`
                                                                                : ""
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-12 mt-3"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "color-secondary-6 font-weight-normal font-14"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Escuela: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              rowItem.studentSchoolName
                                                                                ? rowItem.studentSchoolName
                                                                                : "-"
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row header-row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col"
                                                              },
                                                              [
                                                                _c("em", {
                                                                  staticClass:
                                                                    "fas fa-info-circle color-orange mr-2"
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "color-gray-7 font-weight-bold font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Información Adicional "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row data-row no-gutters"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-4 additionalInfo_item"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "color-secondary-6 font-weight-normal font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Proveedor: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "color-black font-weight-normal font-16 additionalInfo_value"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          rowItem.companyName
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-3 additionalInfo_item"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "color-secondary-6 font-weight-normal font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Municipio: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "color-black font-weight-normal font-16 additionalInfo_value"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          rowItem.locationMunicipalityName
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-md-4 additionalInfo_item"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "color-secondary-6 font-weight-normal font-14"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Lugar de Servicio: "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "color-black font-weight-normal font-16 additionalInfo_value"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          rowItem.locationName
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            rowItem.reasonDescription !==
                                                            null
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-md-12 mt-3 additionalInfo_item"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "color-secondary-6 font-weight-normal font-14"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " Razón de Referido: "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "color-black font-weight-normal font-16 additionalInfo_value"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              rowItem.reasonDescription
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row c-cardContent"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-lg-2 col-12 d-flex py-3 align-items-center bg-secondary-9"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold font-16 text-center w-100 startDate"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "daywithnumber"
                                                            )(rowItem.startDate)
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row m-0 p-3 p-md-0 col"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-6 col-md my-1 bg-white order-1"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mt-1 serviceTypeName_title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                rowItem.evaluationTypeName
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-black font-weight-normal font-16 serviceTypeName_value"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                rowItem.serviceName
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 col-md my-1 bg-white order-3 order-md-2"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mt-1 schedule_title"
                                                        },
                                                        [_vm._v(" Horario: ")]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color-black font-weight-normal font-16 schedule_value"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                rowItem.startTime
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                rowItem.endTime
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 col-md my-1 bg-white col-status order-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-black font-weight-bold font-16 mt-1 estatus_title"
                                                        },
                                                        [_vm._v(" Estatus: ")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "color-black font-16 d-flex align-item-center"
                                                        },
                                                        [
                                                          _c("em", {
                                                            staticClass:
                                                              "fa fa-circle font-12",
                                                            class: `color-${_vm.getAppointmentStatusColor(
                                                              rowItem.statusId !=
                                                                null
                                                                ? rowItem.statusId
                                                                : 0
                                                            )}`
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "color-black font-weight-normal font-16 ml-2 estatus_value"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    rowItem.statusName !=
                                                                      null
                                                                      ? rowItem.statusName
                                                                      : "Disponible"
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-6 col-md d-flex justify-content-end align-items-center bg-white my-1 pt-3 mr-md-4 mr-0 order-2 order-md-4"
                                                    },
                                                    [
                                                      !rowItem.isCoordinated
                                                        ? _c("action-button", {
                                                            attrs: {
                                                              i: "fa fa-edit",
                                                              variant:
                                                                "outline-success pr-0 mt-n3"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "edit-space",
                                                                  _vm.value,
                                                                  rowItem
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      !rowItem.isCoordinated
                                                        ? _c("action-button", {
                                                            attrs: {
                                                              i:
                                                                "fa fa-times-circle",
                                                              variant:
                                                                "outline-danger pr-0 ml-2 mt-n3"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.$emit(
                                                                  "delete-space",
                                                                  rowItem.clientAppointmentSpaceID,
                                                                  _vm.index
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _c(
                                  "div",
                                  { staticClass: "detail-no-data" },
                                  [
                                    _vm.page.data.length === 0
                                      ? _c("not-available-space", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            message:
                                              "No existen espacios disponibles."
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm.page.totalItemCount > 5
                                  ? _c("pagination", {
                                      attrs: { data: _vm.page },
                                      on: {
                                        "pagination-go-page": _vm.setCurrentPage
                                      }
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-sm-12 col-md-8 d-flex py-3 pr-5 align-items-center"
          },
          [
            _c("div", { staticClass: "c-pictureProfile" }, [
              _c("em", {
                staticClass: "fas fa-user-alt fa-stack-1x fa-inverse"
              })
            ]),
            _c(
              "span",
              { staticClass: "color-black font-weight-bold font-18 ml-3" },
              [_vm._v(" " + _vm._s(_vm.value.specialistNumber) + " ")]
            ),
            _c(
              "span",
              { staticClass: "color-black font-weight-normal font-16 ml-4" },
              [_vm._v(" " + _vm._s(_vm.value.specialistName) + " ")]
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "flex-grow-1 d-flex text-right col-12 col-md-4 align-items-center justify-content-end"
          },
          [
            _c(
              "action-button",
              {
                staticClass: "actionButton",
                attrs: { i: "fa fa-plus-circle", variant: "outline-success" },
                on: {
                  click: function($event) {
                    return _vm.$emit("create-space", _vm.value)
                  }
                }
              },
              [_vm._v(" Crear Espacios Disponibles ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }